export const UTM_PARAMETERS_LIST: string[] = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

export const UTM_PARAM_TO_CAMPAIGN_JOURNEY_FIELD: Record<string, keyof CampaignJourneyCreate> = {
  utm_source: "source",
  utm_medium: "medium",
  utm_campaign: "campaign_slug",
  utm_content: "content",
  utm_term: "term",
};

/** matches CampaignJourneyValidationSerializer */
export type CampaignJourneyCreate = {
  source: string;
  medium: string;
  campaign_slug: string;
  content: string;
  term: string;
};

/** Matches marketing.api.serializers.ConsentPreferencesSerializer (read-only) */
export interface ConsentPreferencesResponse {
  sell_share_opt_out: boolean;
  limit_sensitive_data: boolean;
  accept_all_cookies: boolean;
}

/** Matches marketing.api.serializers.ConsentPreferencesSubmitSerializer */
export interface ConsentSubmitPayload {
  source: ConsentSource;
  sell_share_opt_out: boolean;
  limit_sensitive_data: boolean;
  accept_all_cookies: boolean;
}

/** Matches marketing.constants.ConsentSource */
export enum ConsentSource {
  BANNER = "BANNER",
  GPC = "GPC",
}

/**
 * c15t consent format used in the frontend for banner submissions.
 * Transformed to ConsentSubmitPayload before sending to backend.
 */
export interface ConsentSyncPayload {
  experience: boolean;
  functionality: boolean;
  marketing: boolean;
}
